export type ServiceLabel =
  | 'LF | Nacionalidade Portuguesa'
  | 'LF | Cidadania Italiana Judicial'
  | 'LF | Assessoria ao Italiano'
  | 'LF | Serviço Documental'
  | 'all';

export const SERVICE_LABELS: ServiceLabel[] = [
  'all',
  'LF | Nacionalidade Portuguesa',
  'LF | Cidadania Italiana Judicial',
  'LF | Assessoria ao Italiano',
  'LF | Serviço Documental',
];

export const SERVICE_SHORT: Record<ServiceLabel, string> = {
  'all': 'Todos',
  'LF | Nacionalidade Portuguesa': 'Portuguesa',
  'LF | Cidadania Italiana Judicial': 'Italiana Judicial',
  'LF | Assessoria ao Italiano': 'Assessoria',
  'LF | Serviço Documental': 'Documental',
};

export const SERVICE_COLORS: Record<ServiceLabel, string> = {
  'all': 'var(--accent)',
  'LF | Nacionalidade Portuguesa': 'var(--service-1)',
  'LF | Cidadania Italiana Judicial': 'var(--service-2)',
  'LF | Assessoria ao Italiano': 'var(--service-3)',
  'LF | Serviço Documental': 'var(--service-4)',
};

export interface User {
  id: string;
  email: string;
  name: string;
}

export interface MetaKPIs {
  valorUsado: number;
  alcance: number;
  ctr: number;
  cpm: number;
  frequencia: number;
  resultados: number;
  custoPorResultado: number;
}

export interface GoogleKPIs {
  valorUsado: number;
  impressions: number;
  clicks: number;
  ctr: number;
  cpm: number;
  conversions: number;
  costPerConversion: number;
}

export interface KommoKPIs {
  totalLeads: number;
  totalWon: number;
  conversionRate: number;
  totalRevenue: number;
}

export interface KPIData {
  meta: MetaKPIs;
  google: GoogleKPIs;
  kommo: KommoKPIs;
}

export interface TimeseriesPoint {
  date: string;
  metaSpend: number;
  googleSpend: number;
  leads: number;
}

export interface MetaCampaign {
  campaign_id: string;
  campaign_name: string;
  account_id: string;
  source: 'meta';
  spend: number;
  impressions: number;
  reach: number;
  clicks: number;
  ctr: number;
  cpm: number;
  results: number;
  cost_per_result: number;
  service_tag: string | null;
}

export interface GoogleCampaign {
  campaign_id: string;
  campaign_name: string;
  customer_id: string;
  source: 'google';
  spend: number;
  impressions: number;
  clicks: number;
  conversions: number;
  cost_per_conversion: number;
  ctr: number;
  cpm: number;
  service_tag: string | null;
}

export interface MetaAd {
  ad_id: string;
  ad_name: string;
  campaign_id: string;
  campaign_name: string;
  account_id: string;
  spend: number;
  impressions: number;
  reach: number;
  clicks: number;
  ctr: number;
  cpm: number;
  results: number;
}

export interface KommoLead {
  id: string;
  lead_name: string | null;
  pipeline_id: string;
  pipeline_name: string;
  status_id: string;
  status_name: string;
  created_at: string;
  closed_at: string | null;
  sale_value: number;
  service_tag: string | null;
  is_won: number;
  is_lost: number;
}

export interface FunnelStage {
  pipeline_id: string;
  status_id: string;
  status_name: string;
  sort_order: number;
  count: number;
  value: number;
}

export interface KommoFunnelData {
  service: string;
  stages: FunnelStage[];
  totalLeads: number;
  totalWon: number;
  totalRevenue: number;
}

export interface CampaignTag {
  campaign_id: string;
  source: string;
  account_id: string | null;
  campaign_name: string;
  service: string;
  created_at: string;
}

export interface MetaAccount {
  account_id: string;
  name: string;
  currency: string;
  timezone: string;
  synced_at: string;
}

export interface FinanceiroMonth {
  monthStart: string;
  spend: number;
  tax: number;
  total: number;
}

export interface FinanceiroData {
  meta: {
    accounts: MetaAccount[];
    months: FinanceiroMonth[];
  };
  updatedAt: string | null;
}

export interface TimeWindow {
  startDate: string;
  endDate: string;
  preset: 'today' | 'yesterday' | '7d' | '14d' | '30d' | 'this-month' | 'last-month' | 'custom';
}
